import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { isACHorPADS, isCardOrWallet, isBnpl } from 'payments-checkout-lib/utils/paymentMethods';
import CardBillingInfo from './CardBillingInfo';
import BankBillingInfo from './BankBillingInfo';
import CommonBillingAddress from './CommonBillingAddress';
import FullAddress from '../Address/FullAddress';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BillingInfo = ({
  collectShippingAddress,
  collectFullBillingAddress,
  onChange,
  stripePaymentMethod
}) => {
  const {
    formState,
    checkoutSession
  } = usePaymentFormContext();
  const paymentMethod = formState.get('paymentMethod');
  const billingAddress = formState.get('billingAddress');
  const hasCalculateAtCheckoutTaxes = checkoutSession.isAutomatedSalesTaxEnabled;
  if (isCardOrWallet(stripePaymentMethod)) {
    return /*#__PURE__*/_jsx(CardBillingInfo, {
      collectShippingAddress: collectShippingAddress,
      collectFullBillingAddress: collectFullBillingAddress,
      onChange: onChange,
      stripePaymentMethod: stripePaymentMethod
    });
  } else if (isACHorPADS(paymentMethod)) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(BankBillingInfo, {
        stripePaymentMethod: stripePaymentMethod
      }), hasCalculateAtCheckoutTaxes && /*#__PURE__*/_jsx(CommonBillingAddress, {
        collectShippingAddress: collectShippingAddress,
        collectFullBillingAddress: collectFullBillingAddress,
        children: /*#__PURE__*/_jsx(FullAddress, {
          fullAddress: billingAddress.toJS(),
          onChange: onChange
        })
      })]
    });
  } else if (isBnpl(paymentMethod)) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: hasCalculateAtCheckoutTaxes && /*#__PURE__*/_jsx(CommonBillingAddress, {
        collectShippingAddress: collectShippingAddress,
        collectFullBillingAddress: collectFullBillingAddress,
        children: /*#__PURE__*/_jsx(FullAddress, {
          fullAddress: billingAddress.toJS(),
          onChange: onChange
        })
      })
    });
  }
  return null;
};
export default BillingInfo;